import React, { useState } from 'react';
import { Tab } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './../css/detailkendaraan.scss';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // core Swiper
import { moneyParser } from '../constant/currency';

const menu = ['Info', 'Kelengkapan', 'Grade', 'Hasil Inspeksi'];

const DetailKendaraan = ({ item }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const InfoPanel = () => {
    return (
      <div className="col panel-box">
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Nomor Polisi</p>
            <h6>{item.plateNumber}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Nomor Rangka</p>
            <h6>{item.info.chassisNumber}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Merek</p>
            <h6>{item.info.brand}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Nomor Mesin</p>
            <h6>{item.info.engineNumber}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Seri</p>
            <h6>{item.info.series}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Kilometer</p>
            <h6>{item.info.odometer}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Tipe</p>
            <h6>{item.info.type}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Bahan Bakar</p>
            <h6>{item.info.fuel}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>CC</p>
            <h6>{item.info.cylinder}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Warna Fisik</p>
            <h6>{item.info.color}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Transmisi</p>
            <h6>{item.info.transmission}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>KEUR</p>
            <h6>{item.info.keurDate}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Model Kendaraan</p>
            <h6>{item.info.model}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>STNK</p>
            <h6>{item.info.registrationDate}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Tahun</p>
            <h6>{item.info.year}</h6>
          </div>
        </div>
      </div>
    );
  };

  const KelengkapanPanel = () => {
    return (
      <div className="col panel-box">
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>BPKB</p>
            <h6>{item.document.bpkb}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>KTP Pemilik</p>
            <h6>{item.document.ownerId}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Surat Pelepasan Hak</p>
            <h6>{item.document.letterOfRelease}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Kuitansi</p>
            <h6>{item.document.receipt}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Faktur</p>
            <h6>{item.document.invoice}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Faktur A</p>
            <h6>{item.document.formA}</h6>
          </div>
        </div>
      </div>
    );
  };

  const GradePanel = () => {
    return (
      <div className="col panel-box">
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Interior</p>
            <h6>{item.grade.interior}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Mekanikal</p>
            <h6>{item.grade.mesin}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Eksterior</p>
            <h6>{item.grade.exterior}</h6>
          </div>
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Total Score</p>
            <h6>{item.grade.total}</h6>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-6"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <p>Rangka</p>
            <h6>{item.grade.rangka}</h6>
          </div>
        </div>
      </div>
    );
  };

  const InspeksiPanel = () => {
    return (
      <div className="col panel-box">
        <div className="d-flex flex-row" style={{ width: '100%', overflowX: 'scroll' }}>
          {item.inspectionResult.map((item) => {
            return <img style={{ width: '100%', height: '100%' }} src={item} alt={item} />;
          })}
        </div>
      </div>
    );
  };

  return (
    <div
      className="modal fade"
      id="modal-kendaraan"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p>Detail Kendaraan</p>
            <button
              data-dismiss="modal"
              style={{
                borderRadius: '50%',
                width: 25,
                height: 25,
                outline: 'none',
                border: 'none',
                backgroundColor: 'red',
                color: 'white',
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="modal-body detail-kendaraan-modal">
            {item !== null && (
              <div className="container-fluid p-0">
                <div className="row">
                  <div className="col-md-5">
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      loop={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      className="mySwiper"
                    >
                      {item &&
                        item.pictures.map((pic, index) => {
                          return (
                            <SwiperSlide>
                              <img className="swiper-img" src={pic} key={index} alt={pic + index} />
                            </SwiperSlide>
                          );
                        })}
                    </Swiper>
                  </div>
                  <div className="col-md-7">
                    <p>
                      <strong>
                        {item.info.brand} {item.info.series} {item.info.cylinder} {item.info.type} {item.info.year}{' '}
                        {item.info.transmission}
                      </strong>
                    </p>
                    <p style={{ fontSize: '14px' }}>
                      {item.plateNumber} | {item.auctionLocation}, {item.auctionDate} | LOT 162
                    </p>
                    <div className="row mt-4">
                      <div className="col-md-6">
                        <p style={{ fontSize: '12px', marginBottom: '2px' }}>Harga Dasar</p>
                        <p>
                          <strong>{moneyParser(item.basePrice)}</strong>
                        </p>
                      </div>
                      <div className="col-md-6">
                        <p style={{ fontSize: '12px', marginBottom: '2px' }}>Harga Terbentuk</p>
                        <p>
                          <strong>{moneyParser(item.finalPrice)}</strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
                    <Tab.List className="tab-list">
                      {menu.map((item, index) => {
                        return (
                          <Tab key={index} className={({ selected }) => (selected ? 'tab-active' : 'tab')}>
                            {item}
                          </Tab>
                        );
                      })}
                    </Tab.List>
                    <Tab.Panels className="tab-panels">
                      <Tab.Panel>{InfoPanel}</Tab.Panel>
                      <Tab.Panel>{KelengkapanPanel}</Tab.Panel>
                      <Tab.Panel>{GradePanel}</Tab.Panel>
                      <Tab.Panel>{InspeksiPanel}</Tab.Panel>
                    </Tab.Panels>
                  </Tab.Group>
                </div>
              </div>
            )}
          </div>
          <div className="modal-body detail-kendaraan-modal-mobile">
            {item !== null && (
              <div className="container-fluid px-0" style={{ overFlow: 'auto' }}>
                <div className="row">
                  <div className="col-12">
                    <Swiper
                      slidesPerView={1}
                      spaceBetween={30}
                      loop={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      className="mySwiper"
                    >
                      {item &&
                        item.pictures.map((pic, index) => {
                          return (
                            <SwiperSlide>
                              <img className="swiper-img" src={pic} key={index} alt={pic + index} />
                            </SwiperSlide>
                          );
                        })}
                    </Swiper>
                  </div>
                  <div className="col-12 mt-3">
                    <p>
                      <strong>
                        {item.info.brand} {item.info.series} {item.info.cylinder} {item.info.type} {item.info.year}{' '}
                        {item.info.transmission}
                      </strong>
                    </p>
                    <p>
                      {item.plateNumber} | {item.auctionLocation}, {item.auctionDate} | LOT 162
                    </p>
                    <div className="mt-4 d-flex justify-content-start">
                      <div className="d-flex align-items-start mr-5 flex-column">
                        <p>Harga Dasar</p>
                        <h6 className="font-weight-bold">{moneyParser(item.basePrice)}</h6>
                      </div>
                      <div className="d-flex align-items-start flex-column">
                        <p>Harga Terbentuk</p>
                        <h6 className="font-weight-bold">{moneyParser(item.finalPrice)}</h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-3 detail-kendaraan-tab px-1">
                    <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
                      <Tab.List className="tab-list">
                        {menu.map((item, index) => {
                          return (
                            <Tab key={index} className={({ selected }) => (selected ? 'tab-active' : 'tab')}>
                              {item}
                            </Tab>
                          );
                        })}
                      </Tab.List>
                      <Tab.Panels>
                        <Tab.Panel>{InfoPanel}</Tab.Panel>
                        <Tab.Panel>{KelengkapanPanel}</Tab.Panel>
                        <Tab.Panel>{GradePanel}</Tab.Panel>
                        <Tab.Panel>{InspeksiPanel}</Tab.Panel>
                      </Tab.Panels>
                    </Tab.Group>
                  </div>
                </div>
                <div className="row mt-4"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailKendaraan;
